import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=d560604a&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d560604a')) {
      api.createRecord('d560604a', component.options)
    } else {
      api.reload('d560604a', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=d560604a&", function () {
      api.rerender('d560604a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GhxtgWr5BMSO/JS/comp/ErrorMessage.vue"
export default component.exports